import { pathOr } from 'ramda'
import { EmbedConfiguration } from 'types/embed'

const getDefaultFontFamily = themeFont =>
  ['Georgia', 'TimesNewRoman', 'RobotoSlab'].includes(themeFont) ? 'serif' : 'sans-serif'

export const setFontStyleSheet = ({ configuration }: { configuration: EmbedConfiguration }) => {
  const NOT_GOOGLE_FONT = ["Helvetica", "Georgia", "TimesNewRoman", "Arial", "Brandon"]
  const themeFont = pathOr<string>('OpenSans', ['theme', 'fontFamily'], configuration)
  const font = themeFont.replace(/([a-z0-9])([A-Z])/g, '$1 $2')

  if(NOT_GOOGLE_FONT.includes(themeFont)) {
    if (themeFont === 'Brandon') {
      require('../fonts/Brandon/style.css')
    }
  } else {
    const encodedFont = window.encodeURIComponent(font)
    const $linkTag = document.createElement("link")
    $linkTag.rel = 'stylesheet'
    $linkTag.href = `https://fonts.googleapis.com/css?family=${encodedFont}|${encodedFont}:bold&display=swap`
    document.body && document.body.appendChild($linkTag)
  }

  const $styleTag = document.createElement("style")
  $styleTag.type = 'text/css'
  $styleTag.innerHTML = `
    body, html, * {
      font-family: '${font}', ${getDefaultFontFamily(themeFont)};
    }
  `
  const $ref = document.querySelector('head')
  $ref && $ref.appendChild($styleTag)
}

export const setGlobalUserStyleSheet = ({ configuration }: { configuration: EmbedConfiguration }) => {
  const { backgroundColor }  = configuration.theme

  const $styleTag = document.createElement("style")
  $styleTag.type = 'text/css'
  $styleTag.innerHTML = `
    input:focus {
      border: 1px solid #${backgroundColor};
    }
  `

  const $ref = document.querySelector('head')

  $ref && $ref.appendChild($styleTag)
}

// Retrofitted from https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
// Positive percent values will lighten, negative percent values with darken
export const shadeHexColor = (hexCode: string, percent: number = 0) => {
  var R = parseInt(hexCode.substring(1,3), 16)
  var G = parseInt(hexCode.substring(3,5), 16)
  var B = parseInt(hexCode.substring(5,7), 16)

  R = Math.floor(R * (100 + percent) / 100)
  G = Math.floor(G * (100 + percent) / 100)
  B = Math.floor(B * (100 + percent) / 100)

  R = (R < 255) ? R : 255
  G = (G < 255) ? G : 255
  B = (B < 255) ? B : 255

  var RR = ((R.toString(16).length === 1) ? "0" + R.toString(16) : R.toString(16))
  var GG = ((G.toString(16).length === 1) ? "0" + G.toString(16) : G.toString(16))
  var BB = ((B.toString(16).length === 1) ? "0" + B.toString(16) : B.toString(16))

  return `#${RR}${GG}${BB}`
}
